import { render, staticRenderFns } from "./Document-type-graph.vue?vue&type=template&id=f371a9f0"
import script from "./Document-type-graph.vue?vue&type=script&lang=js"
export * from "./Document-type-graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports